import { z } from 'zod/v3';

export const syntaxHighlighterInfoSchema = z.object({
  languages: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      aliases: z.array(z.string()),
    }),
  ),
  themes: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      type: z.enum(['dark', 'light']),
    }),
  ),
});
export type SyntaxHighlighterInfo = z.infer<typeof syntaxHighlighterInfoSchema>;

export const syntaxHighlighterQuerySchema = z.object({
  language: z.string(),
  theme: z.string(),
  code: z.string(),
  colorizeBrackets: z.boolean().optional(),
});
export type SyntaxHighlighterQuery = z.infer<
  typeof syntaxHighlighterQuerySchema
>;

export const syntaxHighlighterOutputSchema = z.object({
  message: z.string().optional(),
  html: z.string(),
});
export type SyntaxHighlighterOutput = z.infer<
  typeof syntaxHighlighterOutputSchema
>;
